import React from 'react';
import { useLang } from '../contexts/LanguageContext';

export default function GuidaTagliePage() {
  const { t } = useLang();

  const tables = [
    {
      title: { it: 'Donna', en: 'Women' },
      headers: [
        { it: 'Taglia', en: 'Size' },
        { it: 'Petto (cm)', en: 'Chest (cm)' },
        { it: 'Vita (cm)', en: 'Waist (cm)' },
        { it: 'Fianchi (cm)', en: 'Hips (cm)' },
      ],
      rows: [
        ['XS', '80-84', '60-64', '86-90'],
        ['S', '84-88', '64-68', '90-94'],
        ['M', '88-92', '68-72', '94-98'],
        ['L', '92-97', '72-77', '98-103'],
        ['XL', '97-102', '77-82', '103-108'],
      ],
    },
    {
      title: { it: 'Uomo', en: 'Men' },
      headers: [
        { it: 'Taglia', en: 'Size' },
        { it: 'Petto (cm)', en: 'Chest (cm)' },
        { it: 'Vita (cm)', en: 'Waist (cm)' },
        { it: 'Fianchi (cm)', en: 'Hips (cm)' },
      ],
      rows: [
        ['S', '88-93', '76-81', '90-95'],
        ['M', '93-98', '81-86', '95-100'],
        ['L', '98-104', '86-92', '100-105'],
        ['XL', '104-110', '92-98', '105-110'],
        ['XXL', '110-116', '98-104', '110-116'],
      ],
    },
  ];

  return (
    <div data-testid="taglie-page" className="min-h-screen bg-[#FAF9F6] pt-24 pb-24">
      <section className="px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-4xl">
          <p className="overline mb-4">{t({ it: 'Assistenza', en: 'Customer Care' })}</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#1C1917] mb-8">
            {t({ it: 'Guida alle Taglie', en: 'Size Guide' })}
          </h1>
          <p className="text-lg text-[#1C1917]/70 leading-relaxed max-w-2xl mb-16">
            {t({
              it: 'I nostri capi hanno una vestibilità regolare italiana. Misura il tuo corpo e confronta con le tabelle qui sotto. In caso di dubbio tra due taglie, consigliamo la più grande.',
              en: 'Our garments have a regular Italian fit. Measure your body and compare with the tables below. If in doubt between two sizes, we recommend the larger one.',
            })}
          </p>

          <div className="space-y-12">
            {tables.map((table) => (
              <div key={table.title.it} data-testid={`taglie-${table.title.it.toLowerCase()}`}>
                <h2 className="text-lg font-medium text-[#1C1917] mb-4">{t(table.title)}</h2>
                <div className="overflow-x-auto bg-white border border-[#E5E0D8]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#1C1917] text-white">
                        {table.headers.map((h) => (
                          <th key={h.it} className="text-left px-6 py-3 font-medium">{t(h)}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {table.rows.map((row, idx) => (
                        <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-[#F2EFE9]'}>
                          {row.map((cell, cidx) => (
                            <td key={cidx} className={`px-6 py-3 ${cidx === 0 ? 'font-medium text-[#4A5D23]' : 'text-[#1C1917]/70'}`}>
                              {cell}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>

          <p className="mt-12 text-sm text-[#57534E]">
            {t({ it: 'Hai bisogno di aiuto? Scrivici a', en: 'Need help? Write to us at' })}{' '}
            <a href="mailto:info@biolosophy.it" className="text-[#4A5D23] hover:underline">info@biolosophy.it</a>
          </p>
        </div>
      </section>
    </div>
  );
}
